// HKDSE Q&A Data - Main file that combines all type-specific Q&A data
import { getTypeAQAByTextId } from './hkdseQADataTypeA';
import { getTypeBQAByTextId } from './hkdseQADataTypeB';
import { getTypeCQAByTextId } from './hkdseQADataTypeC';
import { getTypeDQAByTextId } from './hkdseQADataTypeD';
import { getTypeEQAByTextId } from './hkdseQADataTypeE';

// Combined function to get Q&A data by text ID
export const getQAByTextId = (textId) => {
  // Try to get Q&A data from each type
  let qaData = getTypeAQAByTextId(textId);
  
  if (!qaData) {
    qaData = getTypeBQAByTextId(textId);
  }
  
  if (!qaData) {
    qaData = getTypeCQAByTextId(textId);
  }
  
  if (!qaData) {
    qaData = getTypeDQAByTextId(textId);
  }
  
  if (!qaData) {
    qaData = getTypeEQAByTextId(textId);
  }
  
  return qaData;
};

// Export individual type functions for direct access if needed
export { getTypeAQAByTextId } from './hkdseQADataTypeA';
export { getTypeBQAByTextId } from './hkdseQADataTypeB';
export { getTypeCQAByTextId } from './hkdseQADataTypeC';
export { getTypeDQAByTextId } from './hkdseQADataTypeD';
export { getTypeEQAByTextId } from './hkdseQADataTypeE'; 